<template>
  <div class="py-4 container-fluid" style="margin-top:-10px">
    <div class=" row" style="margin-top:-10px">
      <div class="col-12">
        <span style="color:white" @click="home_clicked()">Chakrit >> </span> 
        <span style="color:white" @click="back_clicked()"> {{this.$store.state.user2.line_display}} >> {{this.influ_name}}</span>
      </div>
    </div>    
    <div class=" row" >
      <div class="col-8">
        <card title="Influencer : " :value="this.influ_name">
        
        </card>
      </div>
      <div class="col-4">
        <card
          title="Points"
          :value="total_points"
        ></card>
      </div>
    </div>
    <div class=" row" style="margin-top:-10px">
      <div class="col-4">
        <card
          title="T-1 Members"
          :value="tier_1_members"
        ></card>
      </div>
      <div class="col-4">
        <card
          title="Total Members"
          :value="all_members"
        ></card>
      </div>

      <div class="col-4">
        <card
          title="Total Exchange"
          :value="total_exchange + '.00'"
        ></card>
      </div>
        <!-- <card
          title="TEST"
          value="10"
          percentage="10"
          iconClass="ni ni-money-coinss"
          iconBackground="bg-gradient-primary"
          detail="Detail naja"
          directionReverse
        ></card> -->

    </div>
    <div class=" row">
      <div class="col-12">
        <t3-table />
      </div>
    </div>
  </div>
</template>



<script>
/* eslint-disable */
// import AuthorsTable from "./components/AuthorsTable.vue";
import T3Table from "./components/T3Table.vue";
import Card from "@/examples/Cards/Card.vue";
import axios from 'axios'
const qs = require('querystring')

var host_api=window.localStorage.getItem('$host_api');

export default {
  name: "t3",
  components: {
    T3Table,
    Card,
  },
  data() {
    return {
      influencer_id : "",
      influ_name : "",
      tier_1_members : 0,
      all_members : 0,
      total_points : 0,
      total_exchange : 0,
      members : [],

    };
  },
  mounted () {
    // var user = window.localStorage.getItem('$logged_user');
    // if (user != 'extra')
    //   this.$router.push('/')

    var influ = this.$store.state.user3;

    this.influ_name = influ.line_display
    this.total_points = influ.point
    this.tier_1_members = this.$store.state.t3.length
    this.all_members = this.count_all_member(this.$store.state.t3)

    // host_api=window.localStorage.getItem('$host_api');
    // const config = {
    //   headers: {
    //     'Content-Type': 'application/x-www-form-urlencoded'
    //   }
    // }
    // const requestBody = {
    //     username: 'Ufc4d40fd780b28e64f5c25c706e54c92',
    // }
    // axios.post(host_api+"/admin/users/extra", qs.stringify(requestBody), config,
    // ).then(response => {
    //   this.influ_name = response.data.user.line_display
    //   this.tier_1_members = response.data.t1.length
    //   this.total_points = response.data.user.point
    //   this.members = response.data.t1
    //   this.all_members = this.count_all_member(response.data.t1);
    // })


  },
  methods : {
    home_clicked() {
      this.$router.push('/referral_extra')
    },
    back_clicked() {
      this.$router.push('/t2')
    },
    count_all_member(members) {
      var all = 0
      var t1 = members.length;
    
      all = t1 

      return all

    },
  }

};
</script>
